import React from "react";
import { Row, Col} from 'antd';
import PropTypes from "prop-types";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { ComponentDivider, SectionHeading,ContributionConfirmationHeading, NavigationBtnContainer, IconsPlaceNew,IconPadding, DataExportPrint, EditButtonWrap,ConfirmDetails } from './styles';
import history from "../../../../../../history/history";
import PrintComponents from "react-print-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import printIcon from "../../../../../../assets/icons/print.svg";
import { BusinessDate } from "../ReviewContributionAndSubmit/styles";
import { StyleLessButton } from "../../../../../../CommonComponents/commonStyles";
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import BreadcrumbComponent from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import Allocation from "../ReviewContributionAndSubmit/Components/ReviewAllocation/Allocation";
import InvestmentAllocationCard from "../ReviewContributionAndSubmit/Components/InvestmentAllocationCard/InvestmentAllocationCard";
import {ContentContainer} from "../../styles";
import { SuccessMessage } from "../../../ContributionActivity/Components/ViewContribution/Components/FundingInstructions/styles";
import FundingInst from "../FundingInstructions/Components/LOADocs/FundingInstructions" ;
import ContributionType from "../ReviewContributionAndSubmit/Components/ContributionType/ContributionType";
import Notice from "./Components/Notice";
import ConfirmationProcessingDetails from "./Components/ConfirmationProcessingDetails/ConfirmationProcessingDetails";
import { contributionConfirmationState } from "../../selectors";

class Confirmation extends React.Component {

    navigateContributionActivity(){
      try {
        history.push("/contributions/activity");
        window.scrollTo(0, 0);
      } catch (error) {
        recordError(error);
      }
    }

    makeAnotherContribution(){
      try {
        history.push("/contributions/make-a-contribution")
      } catch (error) {
        recordError(error);
      }
    }

    analyticsTracking = (value) => {
      try {
        initiateTracking(value.toLowerCase(),'Contribution Confirmation', '' ,value);
      } catch (error) {
        recordError(error);
      }
    }

    render() {
        this.breadcrumbRoutes = () => {
            return [
              {
                routeName: "Home",
                path: "/"
              },
              {
                routeName: "Contributions",
                path: "/contributions"
              },
              {
                routeName: "Make a Contribution",
                path: "/contributions/make-a-contribution"
              }
            ];
          };
        return (
            <ContentContainer marginTop="162px">
            <div className="fluid">
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
                <ContributionConfirmationHeading fontSize="42px" mfSize="36px" marginBottom="15px" mb="40px bvv">Contribution Confirmation</ContributionConfirmationHeading>
                <SuccessMessage className='mb-20'>{this.props.drupalData ? <div dangerouslySetInnerHTML={{ __html: this.props.drupalData.confirmationSuccessMessage.field_success_message }}></div> : 'You successfully submitted your contribution. Thank you for your generosity!'}</SuccessMessage>
                <Notice noticeContent={this.props.drupalData}></Notice>
                <ComponentDivider marginTop="40px" marginBottom="40px" />


                <Row >
              <Col lg={{ span: 16}} md={{ span: 16 }} xs={{ span: 24 }}>
              <ConfirmationProcessingDetails />
                </Col>
               
                <div>
                <IconsPlaceNew>
                  <PrintComponents                
                    className=""
                    trigger={
                      <StyleLessButton>
                        <IconPadding data-test="print-comp" className="ml2" onClick={() => this.analyticsTracking('Print')}>
                          <img src={printIcon} alt="printIcon"/>
                          <DataExportPrint>PRINT</DataExportPrint>
                        </IconPadding>
                      </StyleLessButton>
                    }
                  >
                    <div>
                    <ContentContainer marginTop="162px">
            <div className="fluid">
                    <SectionHeading fontSize="42px" mfSize="36px" marginBottom="50px">Contribution Confirmation</SectionHeading>
                    <SuccessMessage className='mb-20'>{this.props.drupalData ? <div dangerouslySetInnerHTML={{ __html: this.props.drupalData.confirmationSuccessMessage.field_success_message }}></div> : 'You successfully submitted your contribution. Thank you for your generosity!'}</SuccessMessage>
                <Notice></Notice>
                    <ConfirmationProcessingDetails />
                <ComponentDivider marginTop="30px" marginBottom="30px" />
                <EditButtonWrap>
                  <SectionHeading fontSize="24px" mfSize="20px">Contribution Type</SectionHeading>
               </EditButtonWrap>
                <ContributionType />
                <EditButtonWrap>
                <SectionHeading fontSize="24px" mfSize="20px" mb='0px' marginBottom="20px" print>Investment Option Allocation </SectionHeading>
               </EditButtonWrap>
               <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
                <Allocation />
                <ComponentDivider />
                </div>
                </ContentContainer>
              
                    </div>
                  </PrintComponents>
                </IconsPlaceNew>
                </div>
               
              
              </Row>
                <ComponentDivider marginTop="40px" marginBottom="40px" />
                <SectionHeading marginBottom="20px" fontSize="24px" mfSize="20px">Contribution Type</SectionHeading>
                <ContributionType isConfirmation={true}/>
                <SectionHeading mb='20px' marginBottom="20px" fontSize="24px" mfSize="20px">Investment Allocation</SectionHeading>
                <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
                <ConfirmDetails>
                  <Row>
                    <Col xs={0} lg={24}>
                      <Allocation />
                    </Col>
                    <Col xs={24} lg={0}>
                        <InvestmentAllocationCard />
                    </Col>
                  </Row>
                </ConfirmDetails>
                <ComponentDivider marginTop="40px" marginBottom="40px" />
                <SectionHeading marginBottom="20px" fontSize="24px" mfSize="20px">Funding Instructions </SectionHeading>
                <FundingInst />
                <NavigationBtnContainer>
                    <GeneralButton 
                      data-test ="make-another-contribution"
                      text = "MAKE ANOTHER CONTRIBUTION"
                      width = "fit-content"
                      mobWidth = "100%"
                      type = "functional"
                      inverted = {true}
                      onClick={() => {this.makeAnotherContribution()}}
                    />
                    <GeneralButton
                     data-test ="view-all-contribution" 
                      text = "VIEW ALL CONTRIBUTIONS"
                      width = "fit-content"
                      mobWidth = "100%"
                      onClick={() => {this.navigateContributionActivity()}}
                    />
                </NavigationBtnContainer>
            </div>
            </ContentContainer>
        );
    }
}

Confirmation.propTypes = {
  drupalData: PropTypes.object,
  lastBusinessDate: PropTypes.string,
}

const mapStateToProps = state => ({
  ...contributionConfirmationState(state.toJS())
});

export default withRouter(connect(mapStateToProps, null)(Confirmation));

